module.exports = __webpack_public_path__ + "static/media/PROMOCIONAL.88bf07c0.jpg";